import {availableCoutries} from "../util_const"

const availableCountriesMixin = {
    methods: {
        getAvaiableCountries() {
            const arr_avaiableCountries = availableCoutries.map((c)=>{
                return {
                    text: c[0],
                    value: c[1]

                }
            })
            return arr_avaiableCountries
        },
    }
}

export default availableCountriesMixin